// The five pre-contract inputs, shared so neither surface can offer four of them.
//
// Split from lolerPreContract.ts (the pure half) rather than living beside it: the server's own
// parity test imports the canonical field list to check the MCP tool carries all of it, and
// server/tsconfig.json sets no --jsx, so a module holding a component cannot be read from there.
// The logic is what both trees need; the inputs are what only the browser needs.
import { PRE_CONTRACT_FIELDS, type PreContractDetails } from "./lolerPreContract";

const FIELD_LABEL: Record<(typeof PRE_CONTRACT_FIELDS)[number], string> = {
  customerName: "Customer name",
  customerEmail: "Customer email",
  customerPhone: "Customer phone",
  siteName: "Site name",
  siteAddress: "Site address",
};

/**
 * The five pre-contract inputs, shared so neither surface can offer four of them.
 *
 * The classes come from the caller because the two surfaces have different label densities (the
 * sweep card is compact), and restyling one of them was never part of sharing the fields. idPrefix
 * keeps each label/input association unique when several cards render at once.
 */
export function PreContractFields({
  value,
  onChange,
  disabled,
  idPrefix,
  labelCls,
  inputCls,
  className,
}: {
  value: PreContractDetails;
  onChange: (patch: Partial<PreContractDetails>) => void;
  disabled?: boolean;
  idPrefix: string;
  labelCls: string;
  inputCls: string;
  className?: string;
}) {
  return (
    <div className={className ?? "grid grid-cols-1 gap-3 sm:grid-cols-2"}>
      {PRE_CONTRACT_FIELDS.map((k) => (
        <div key={k}>
          <label className={labelCls} htmlFor={`${idPrefix}-${k}`}>
            {FIELD_LABEL[k]}
          </label>
          <input
            id={`${idPrefix}-${k}`}
            className={inputCls}
            value={value[k]}
            disabled={disabled}
            onChange={(e) => onChange({ [k]: e.target.value } as Partial<PreContractDetails>)}
          />
        </div>
      ))}
    </div>
  );
}
